import { render } from "./PredictPopup.vue?vue&type=template&id=7ae1372e&scoped=true&ts=true"
import script from "./PredictPopup.vue?vue&type=script&lang=ts"
export * from "./PredictPopup.vue?vue&type=script&lang=ts"

import "./PredictPopup.vue?vue&type=style&index=0&id=7ae1372e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae1372e"]])

export default __exports__